import { RouteConfig } from '../types';
import { publicRoutes } from './publicRoutes';
import { authRoutes } from './authRoutes';
import { agencyRoutes } from './agencyRoutes';
import { promotoraRoutes } from './promotoraRoutes';
import { brokerRoutes } from './brokerRoutes';
import { agenteRoutes } from './agenteRoutes';
import { clientRoutes } from './clientRoutes';
import {
  legalRoutes,
  accountingRoutes,
  operationalRoutes,
  condominiumRoutes,
} from './specialModulesRoutes';
import { adminRoutes } from './adminRoutes';
import { erpRoutes } from './erpRoutes';
import { networkRoutes } from './networkRoutes';
import { errorRoutes } from './errorRoutes';

export const allRoutes: RouteConfig[] = [
  ...publicRoutes,
  ...authRoutes,
  ...agencyRoutes,
  ...promotoraRoutes,
  ...brokerRoutes,
  ...agenteRoutes,
  ...clientRoutes,
  ...legalRoutes,
  ...accountingRoutes,
  ...operationalRoutes,
  ...condominiumRoutes,
  ...adminRoutes,
  ...erpRoutes,
  ...networkRoutes,
  ...errorRoutes,
];

export {
  publicRoutes,
  authRoutes,
  agencyRoutes,
  promotoraRoutes,
  brokerRoutes,
  agenteRoutes,
  clientRoutes,
  legalRoutes,
  accountingRoutes,
  operationalRoutes,
  condominiumRoutes,
  adminRoutes,
  erpRoutes,
  networkRoutes,
  errorRoutes,
};
